<script lang="ts">
	import { format } from 'svelte-i18n';
	import { push } from 'svelte-spa-router';

	import type { DeviceEnergyDesignation } from 'src/components/Settings/HomeManagement/shared/solar-setup-helpers';
	import { ENERGY_PV_SETTINGS_HREF } from 'src/components/EnergyMonitoring/helpers/energy_widget_state_helpers';

	import { Alert } from '@Shelly/shelly-design-system';

	export let designation: DeviceEnergyDesignation;

	const openHomeSettings = (): void => {
		push('/settings/home');
	};

	const openSolarSetup = (): void => {
		push(ENERGY_PV_SETTINGS_HREF);
	};
</script>

{#if designation.isMainEnergyMeter}
	<Alert
		class="mb-m"
		type="success"
		heading={$format('energy_category_main_meter_title', {
			default: 'Set up as main home energy meter',
		})}
		message={$format('energy_category_main_meter_description', {
			default:
				'This device measures total consumption for the home. Change this in Home settings.',
		})}
		cta={{ title: $format('button_open_home_settings', { default: 'Open Home settings' }) }}
		on:cta_click={openHomeSettings}
	/>
{/if}

{#if designation.solarRole}
	<Alert
		class="mb-m"
		type="info"
		heading={$format('energy_category_solar_meter_title', {
			default: 'Designated as solar meter',
		})}
		message={designation.solarRole === 'grid'
			? $format('energy_category_solar_meter_grid_description', {
					default:
						'This device is the grid meter in Solar setup. Change this in Home settings.',
				})
			: $format('energy_category_solar_meter_generation_description', {
					default:
						'This device is the generated-energy meter in Solar setup. Change this in Home settings.',
				})}
		cta={{ title: $format('button_open_solar_setup', { default: 'Open Solar setup' }) }}
		on:cta_click={openSolarSetup}
	/>
{/if}

{#if designation.leftoverSourceUsage}
	<Alert
		class="mb-m"
		type="warning"
		heading={designation.leftoverSourceUsage === 'grid_source'
			? $format('energy_category_leftover_grid_title', {
					default: 'Previously marked as grid source',
				})
			: $format('energy_category_leftover_solar_title', {
					default: 'Previously marked as generated energy',
				})}
		message={$format('energy_category_leftover_description', {
			default:
				'Finish setup in Home settings by designating this device as the main energy meter or a solar meter.',
		})}
		cta={{ title: $format('button_open_home_settings', { default: 'Open Home settings' }) }}
		on:cta_click={openHomeSettings}
	/>
{/if}
